<div [formGroup]="form()!">
  <div formArrayName="questions" class="d-flex flex-column mt-3 gap-3">
    @for (questionForm of questionsControls.controls; let i = $index; track i) {
      <cf-question-field
        [questionForm]="questionForm"
        [question]="booking()!.questions![i]"
        [answerType]="booking()!.questions![i].answer_type"
      ></cf-question-field>
    }
  </div>
</div>
